export default __webpack_public_path__ + "static/media/CNo.55-0.671fa58f.jpg";